<!--
Screen to display library items.

@author ab557z
-->
<template>
  <div id="contain" class="container">
    <Nav name="Library" />
    <Spinner ref="spinner_ref" />
    <div style="display: flex; width: 100%;">
      <div style="width: 50%; margin-left: 24px;">
        <p class="blueText">My Library</p>
      </div>
      <div style="width: 50%;">
        <div class="libraryAccLink">
          <a @click="goToCatalogue()" style="color:#003865;">Library login</a>
          <font-awesome-icon style="color: #003865; font-size: 16px; margin-left: 5px;" icon="external-link" size="lg"></font-awesome-icon>
        </div>
      </div>
    </div>

    <ul class="findaspace-nav-tabs nav nav-tabs eventNavUl">
      <!-- li
        role="button"
        class="eventNav"
        style="width: 50% !important"
        :class="dateActiveClass(0)"
        @click="selectTab(0)"
      >
        On loan
      </li -->
      <!-- li
        role="button"
        class="eventNav"
        style="width: 50% !important"
        :class="dateActiveClass(1)"
        @click="selectTab(1)"
      >
        On hold
      </li -->
      <!-- uncomment the above tabs and delete the following header -->
      <!-- when we re-implement 'items on hold' -->
      <div class="blueSubheader">Items on loan</div>
    </ul>

    <!-- error if any -->
    <div v-if="errorOccurred" class="tabContent">
      <div v-if="noAccount" class="errorMessage">
        <Announcement category="40" />
      </div>
      <div v-else class="errorMessage">
        {{ errorMsg }}
      </div>
    </div>
    <div class="tabContent noResults" v-if="!errorOccurred" v-show="fullResults.length === 0 && loading == false">
      No items on {{ seltab == 0 ? 'loan' : 'hold' }}
    </div>
    <!-- checkout -->
    <div v-if="!errorOccurred" v-show="seltab == 0 && loading == false" class="tabContent">
      <Book
        v-bind:key="index"
        v-for="(r, index) in results"
        :title="r.title"
        :author="r.authors[0]"
        typeOfDate="Due"
        :date="r.dueDate"
        :shortLoan="r.shortLoan"
      />
    </div>

    <!-- hold -->
    <div v-if="!errorOccurred" v-show="seltab == 1 && loading == false" class="tabContent">
      <Book
        v-bind:key="index"
        v-for="(r, index) in results"
        :title="r.title"
        :author="r.authors[0]"
        typeOfDate="Available"
        :date="r.availableDate"
        :holdLocation="r.holdLocation"
      />
    </div>

    <div v-if="showBtn() && loading == false" @click="showMore()" class="showMoreBtn">
      Show {{ btnText() }}
    </div>

    <div id="pusher" />
    <Footer active="library" tab_i="5" />
  </div>
</template>

<script setup>
import axios from 'axios'
import Footer from '@/components/FooterMenu.vue'
import Book from '@/components/library/Book.vue'
import Announcement from '@/components/Announcement.vue'
import Spinner from '@/components/Spinner.vue'
import { onMounted, ref } from 'vue'
import { useRoute, /*useRouter*/ } from 'vue-router'

import { useStringUtil } from '@/composables/StringMethods.js'

const { isEmpty } = useStringUtil() 

const route = useRoute()
// const router = useRouter()
const seltab = ref(0)
const results = ref({})
const fullResults = ref({})
const errorOccurred = ref(false)
const noAccount = ref(false)
const errorMsg = ref('')
const loading = ref(true)
const spinner_ref = ref(null)
const endpoint = ref(null)

onMounted(() => {
  let requestedTab = route.params.tab
  console.log(requestedTab)
  if (typeof requestedTab !== 'undefined') {
    const reqTab = parseInt(requestedTab)
    seltab.value = reqTab
  }
  getBooks()
})

function showBtn () {
  return fullResults.value.length > 3
}

function btnText () {
  return fullResults.value.length - results.value.length == 0
    ? 'less'
    : 'more'
}

function showMore () {
  var frLen = fullResults.value.length
  var rLen = results.value.length
  let diff = frLen - rLen
  var temp = {}
  // show less behaviour
  if (diff <= 0) {
    results.value = fullResults.value.slice(0, 3)
  }
  // show more behaviour
  if (diff >= 3) {
    temp = fullResults.value.slice(rLen, rLen + 3)
  } else {
    temp = fullResults.value.slice(rLen, rLen + diff)
  }

  for (var x in temp) {
    results.value.push(temp[x])
  }
}

function getBooks () {
  loading.value = true
  results.value = {}
  spinner_ref.value.spin()
  endpoint.value = seltab.value == 0 ? 'checkouts' : 'holds'
  let url = '/timetable/library/' + endpoint.value
  axios.get(url).then((response) => {
    fullResults.value = response.data
    // console.log(this.fullResults)
    results.value =
      fullResults.value.length > 3
        ? fullResults.value.slice(0, 3)
        : fullResults.value
    spinner_ref.value.stop()
    if (fullResults.value.length === 1 && !isEmpty(fullResults.value[0].message)) {
      errorOccurred.value = true
      errorMsg.value = fullResults.value[0].message
      // if the problem is the user has no library account
      // display the nice courteous message kept in the db
      if (typeof errorMsg.value === 'string' && errorMsg.value.startsWith('No user found for')) {
          noAccount.value = true
      }
    }
  })
    .finally(() => {
      loading.value = false
    })
}

/*
function dateActiveClass (tabNumber) {
  return {
    dateActive: seltab.value == tabNumber,
    dateInactive: seltab.value != tabNumber
  }
}


function selectTab (t) {
  let newtab = parseInt(t)
  if (seltab.value != newtab) {
    seltab.value = t + 0
    router.push('/library/' + t)
    console.log(seltab.value)
  }
  getBooks()
}
*/

function goToCatalogue () {
  if (process.env.VUE_APP_WS_URL.includes('frontdoor')) { // then we're in prod
  // this works for now, but use announcement component in future
    window.open('https://eleanor.lib.gla.ac.uk/patroninfo', '_blank').focus()
  } else {
    window.open('https://rigby.lib.gla.ac.uk/patroninfo', '_blank').focus()
  }
}

</script>
<style lang="scss" scoped>
.noResults {
  font-style: italic;
  font-weight: 400;
  text-align: center;
}
.showMoreBtn {
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 21px;
  align-items: center;
  text-align: center;
  color: #ffffff;
  height: 54px;
  margin: 24px;
  padding-top: 12px;

  background: #003865;
  border-radius: 12px;
  border-color: #003865;
  border-style: solid;
}
.blueText {
  margin-top: 24px;
  font-family: "PTSans";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  /* identical to box height, or 120% */
  color: #003865;
}
.blueSubheader {
  margin: 12px 24px 12px 24px;
  font-family: "PTSans";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 120% */
  color: #003865;
}
.libraryAccLink {
  margin: 25px auto 0px auto;
  font-family: "PTSans";
  font-style: normal;
  font-weight: 700;
  width: fit-content;
  font-size: 16px;
  color: #003865;
}

.errorMessage {
  margin: 24px;
  font-weight: 700;
  font-size: 18;
}
.start-message {
  margin-left: 24px;
  margin-right: 24px;
}

.noBookingAccess {
  margin: 20px;
}
.tabContent {
  margin-top: 8px;
}
.dateActive {
  background: inherit;
  border-bottom: 4px solid #951272;
  color: #951272;
  font-weight: 900;
}
.dateActive a {
  color: #951272;
}
.dateInactive a {
  color: #003865;
}
.eventNav {
  font-weight: 900;
  width: 50%;
}
.eventNavUl {
  padding-left: 0% !important;
  padding-right: 0% !important;
  border-bottom: 0px !important;
  overflow: hidden;
}
.eventNav {
  display: block;
  width: 50%;
  text-align: center;
  line-height: 50px;
  height: 50px;
}
.start-header {
  margin-top: 25px;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 23px;
  color: #0a3875;
}
.start-text {
  margin-top: 20px;
  margin-bottom: 20px;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 21px;
}
.findaspace-nav-tabs {
  background-color: #f0f1f1 !important;
}
.accessAbleLogo {
  margin-top: 21px;
  margin-bottom: 14px;
}
.accessAbleLogo img {
  width: 160px;
  height: 32px;
}
.accessAbleText {
  font-size: 18px;
  font-weight: 400;
  text-align: left;
}
.aaContainer {
  width: 100%;
  text-align: center;
  margin-bottom: 16px;
}
.aaSeeMoreBtn input {
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 21px;
  align-items: center;
  text-align: center;
  color: #ffffff;
  height: 55px;
  width: 100%;
  margin-top: 34px;
  margin-bottom: 38px;

  background: #003865;
  border-radius: 12px;
  border-color: #003865;
  border-style: solid;
}
</style>
